import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const MachineGetList = createAsyncThunk(
  "MachineGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE.GET_LIST_BY_REVIEWER_ID,
          body: data,
        },
        true,
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
export const MyMachineGetList = createAsyncThunk(
  "MyMachineGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: API_URL.BASEURL + API_URL.MACHINE.GET_MY_MACHINE_LIST,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const GetReviewerComment = createAsyncThunk(
  "GetReviewerComment",

  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",

          url: `${
            API_URL.BASEURL + API_URL.MACHINE.GET_REVIEWR_COMMENT
          }?machineId=${data?.machineId ? data?.machineId : 0}&versionNumber=${
            data?.version ? data?.version : ""
          }`,
          body: {},
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const UpdateReviewComment = createAsyncThunk(
  "UpdateReviewComment",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE.UPDATE_REVIEWR_COMMENT,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineVersionById = createAsyncThunk(
  "GetMachineVersionById",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: `${
            API_URL.BASEURL + API_URL.MACHINE.GET_MACHINE_VERSION_BY_MACHINE_ID
          }?machineId=${data?.id}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineVersion = createAsyncThunk(
  "GetMachineVersion",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.GET_MACHINE_VERSION,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const UpdateMachineStatus = createAsyncThunk(
  "UpdateMachineStatus",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE.UPDATE_MACHINE_STATUS,
          body: {
            machineid: data?.id,
            status: data?.status,
            note: data?.note,
          },
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const GetRepoStrcture = createAsyncThunk(
  "GetRepoStrcture",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE.GET_GIT_REPO_STRUCTURE,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetRepoFileContent = createAsyncThunk(
  "GetRepoFileContent",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE.GET_GIT_REPO_FILE_CONTENT,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineDetailByPrimaryKey = createAsyncThunk(
  "GetMachineDetailByPrimaryKey",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINEGETBYPRIMARYKEYINDETAILS,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const UpdateMachineRetirementStatus = createAsyncThunk(
  "UpdateMachineRetirementStatus",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url:
            API_URL.BASEURL + API_URL.MACHINE.CHANGE_MACHINE_RETIREMENT_STATUS,
          body: data,
        },
        false
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) {}
  }
);

export const MachinePurchaseList = createAsyncThunk(
  "MachinePurchaseList",
  async (data, { dispatch }) => {
    try {
      let url = API_URL.BASEURL + API_URL.MACHINE.GET_MACHINE_PURCHASE_LIST;
      if (data?.machineName) {
        url = `${API_URL.BASEURL}${API_URL.MACHINE.GET_MACHINE_PURCHASE_LIST}?machinename=${data?.machineName}`;
      }
      let resData = await apiCall(
        {
          method: "GET",
          // url: API_URL.BASEURL + API_URL.MACHINE.GET_MACHINE_PURCHASE_LIST,
          url: url,
          body: data,
        },
        false,
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetListBySubscriberId = createAsyncThunk(
  "GetListBySubscriberId",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINEGETLISTBYSUBSCRIBERID,
          body: data,
        },
        true,
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetListBySearch = createAsyncThunk(
  "GetListBySearch",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINEGETLISTBYSEARCH,
          body: data,
        },
        true,
        true
      );

      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const DeprecateMachine = createAsyncThunk(
  "DeprecateMachine",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL.DEPRECATE_MACHINE,
          body: data,
        },
        true
      );

      let response = apiResponse(true, resData);

      return response;
    } catch (error) {}
  }
);
export const DiscontinueMachine = createAsyncThunk(
  "DiscontinueMachine",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL.DISCONTINUE_MACHINE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const MachineVersionUpdate = createAsyncThunk(
  "MachineVersionUpdate",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL.MACHINE_VERSION_UPDATE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const UpdateMachine = createAsyncThunk(
  "UpdateMachine",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL?.MACHINE?.UPDATE_MACHINE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const GetMachineDropdownList = createAsyncThunk(
  "GetMachineDropdownList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.GETMACHINEDROPDOWNLIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachinePortfolioList = createAsyncThunk(
  "GetMachinePortfolioList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.MACHINE?.GET_MACHINE_PORTFOLIO_LIST,
          body: data,
        },
        true
      );

      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const SaveMachineSubscriber = createAsyncThunk(
  "SaveMachineSubscriber",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.SAVE_MACHINE_SUBSCRIBER,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const AssignPrivateMachine = createAsyncThunk(
  "AssignPrivateMachine",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.ASSIGN_PRIVATE_MACHINE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const GetSimilarMachineList = createAsyncThunk(
  "GetSimilarMachineList",
  async (data, { dispatch }) => {
    try {
      let similarMachineListResponse = await apiCall(
        {
          method: "GET",
          url: `${
            API_URL.BASEURL + API_URL.MACHINE.GET_SIMILAR_MACHINE_LIST
          }?industryid=${data?.industryId}&categoryid=${
            data?.categoryId
          }&machineid=${data?.id}`,
        },
        false
      );

      let response = apiResponse(false, similarMachineListResponse);
      return response;
    } catch (error) {}
  }
);

export const GetMachineVersionDetail = createAsyncThunk(
  "GetMachineVersionDetail",
  async (data, { dispatch }) => {
    try {
      let similarMachineListResponse = await apiCall(
        {
          method: "GET",
          url: `${
            API_URL.BASEURL + API_URL.MACHINE.GET_MACHINE_VERSION_DETAIL
          }?machineId=${data?.m_Id}&versionNumber=${data?.v_no}`,
        },
        false
      );
      let response = apiResponse(false, similarMachineListResponse);
      return response;
    } catch (error) {}
  }
);

export const GetMachineDashboardList = createAsyncThunk(
  "GetMachineDashboardList",
  async (data, { dispatch }) => {
    try {
      let machineListResponse = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE.GET_MACHINE_DASHBOARD_LIST,
          body: data,
        },
        true,
        true
      );

      let response = apiResponse(false, machineListResponse);
      return response;
    } catch (error) {}
  }
);

export const MachineRemoveFromLibrary = createAsyncThunk(
  "MachineRemoveFromLibrary",
  async (data, { dispatch }) => {
    
    try {
      let machineListResponse = await apiCall(
        {
          method: "GET",
          url: `${
            API_URL.BASEURL +
            API_URL.MACHINE.MACHINE_VERSION_REMOVE_FROM_LIBRARY
          }?machineId=${data}`,
          // body: data,
        },
        false
      );
      let response = apiResponse(true, machineListResponse);
      return response;
    } catch (error) {}
  }
);

export const GetAllKpiData = createAsyncThunk(
  "GetAllKpiData",
  async (data, { dispatch }) => {
    try {
      const machineId = data?.machineid || data?.id || data;
      let resData = await apiCall(
        {
          method: "GET",
          url: `${API_URL.BASEURL + API_URL.GETALLKPIDATA}?machineid=${machineId}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineRunStatus = createAsyncThunk(
  "GetMachineRunStatus",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.GETMACHINERUNSTATUS,
          body: {
            machineid: data?.machineid,
            startdate: data?.startdate,
            enddate: data?.enddate,
          },
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineUsageTrend = createAsyncThunk(
  "GetMachineUsageTrend",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.GETMACHINEUSAGETREND,
          body: {
            machineid: data?.machineid,
            startdate: data?.startdate,
            enddate: data?.enddate,
          },
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineEarningTrend = createAsyncThunk(
  "GetMachineEarningTrend",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.GETMACHINEEARNINGTREND,
          body: {
            machineid: data?.machineid,
            startdate: data?.startdate,
            enddate: data?.enddate,
          },
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetMachineResourceUsage = createAsyncThunk(
  "GetMachineResourceUsage",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.GETMACHINERESOURCEUSAGE,
          body: {
            machineid: data?.machineid,
            startdate: data?.startdate,
            enddate: data?.enddate,
          },
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  MachineGetListData: {
    data: null,
    error: null,
  },
  GetReviewerCommentData: {
    data: null,
    error: null,
  },
  UpdateReviewCommentData: {
    data: null,
    error: null,
  },
  GetMachineVersionData: {
    data: null,
    error: null,
  },
  GetMachineVersionByIdData: {
    data: null,
    error: null,
  },
  UpdateMachineStatusData: {
    data: null,
    error: null,
  },
  GetRepoStrctureData: {
    data: null,
    error: null,
  },
  GetRepoFileContentData: {
    data: null,
    error: null,
  },
  GetMachineDetailByPrimaryKeyData: {
    data: null,
    error: null,
  },
  UpdateMachineRetirementStatusData: {
    data: null,
    error: null,
  },
  MyMachineGetListData: {
    data: null,
    error: null,
  },
  MachinePurchaseListData: {
    data: null,
    error: null,
  },
  GetListBySubscriberIdData: {
    data: null,
    error: null,
  },
  GetListBySearchData: {
    data: null,
    error: null,
  },
  DeprecateMachineData: {
    data: null,
    error: null,
  },
  DiscontinueMachineData: {
    data: null,
    error: null,
  },
  UpdateMachineData: {
    data: null,
    error: null,
  },
  GetMachineDropdownListData: {
    data: null,
    error: null,
  },
  GetMachinePortfolioListData: {
    data: null,
    error: null,
  },
  MachineVersionUpdateData: {
    data: null,
    error: null,
  },
  SaveMachineSubscriberData: {
    data: null,
    error: null,
  },
  AssignPrivateMachineData: {
    data: null,
    error: null,
  },
  GetSimilarMachineListData: {
    data: null,
    error: null,
  },
  GetMachineDashboardListData: {
    data: null,
    error: null,
  },
  GetMachineVersionDetailData: {
    data: null,
    error: null,
  },
  MachineRemoveFromLibraryData: {
    data: null,
    error: null,
  },
};

const MachineSlice = createSlice({
  name: "MACHINE",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    //   setGetWorkFlowByID: (state) => {
    //     state.GetWorkFlowByIDData.data = null;
    //   },
  },

  extraReducers: (builder) => {
    builder
      .addCase(MachineGetList.fulfilled, (state, action) => {
        state.MachineGetListData.data = action.payload;
      })
      .addCase(MachineGetList.rejected, (state, action) => {
        state.MachineGetListData.error = action.error.message;
      })
      .addCase(MyMachineGetList.fulfilled, (state, action) => {
        state.MyMachineGetListData.data = action.payload;
      })
      .addCase(MyMachineGetList.rejected, (state, action) => {
        state.MyMachineGetListData.error = action.error.message;
      })
      .addCase(GetReviewerComment.fulfilled, (state, action) => {
        state.GetReviewerCommentData.data = action.payload;
      })
      .addCase(GetReviewerComment.rejected, (state, action) => {
        state.GetReviewerCommentData.error = action.error.message;
      })
      .addCase(UpdateReviewComment.fulfilled, (state, action) => {
        state.UpdateReviewCommentData.data = action.payload;
      })
      .addCase(UpdateReviewComment.rejected, (state, action) => {
        state.UpdateReviewCommentData.error = action.error.message;
      })
      .addCase(GetMachineVersionById.fulfilled, (state, action) => {
        state.GetMachineVersionByIdData.data = action.payload;
      })
      .addCase(GetMachineVersionById.rejected, (state, action) => {
        state.GetMachineVersionByIdData.error = action.error.message;
      })
      .addCase(GetMachineVersion.fulfilled, (state, action) => {
        state.GetMachineVersionData.data = action.payload;
      })
      .addCase(GetMachineVersion.rejected, (state, action) => {
        state.GetMachineVersionData.error = action.error.message;
      })
      .addCase(UpdateMachineStatus.fulfilled, (state, action) => {
        state.UpdateMachineStatusData.data = action.payload;
      })
      .addCase(UpdateMachineStatus.rejected, (state, action) => {
        state.UpdateMachineStatusData.error = action.error.message;
      })
      .addCase(GetRepoStrcture.fulfilled, (state, action) => {
        state.GetRepoStrctureData.data = action.payload;
      })
      .addCase(GetRepoStrcture.rejected, (state, action) => {
        state.GetRepoStrctureData.error = action.error.message;
      })
      .addCase(GetRepoFileContent.fulfilled, (state, action) => {
        state.GetRepoFileContentData.data = action.payload;
      })
      .addCase(GetRepoFileContent.rejected, (state, action) => {
        state.GetRepoFileContentData.error = action.error.message;
      })
      .addCase(GetMachineDetailByPrimaryKey.fulfilled, (state, action) => {
        state.GetMachineDetailByPrimaryKeyData.data = action.payload;
      })
      .addCase(GetMachineDetailByPrimaryKey.rejected, (state, action) => {
        state.GetMachineDetailByPrimaryKeyData.error = action.error.message;
      })
      .addCase(UpdateMachineRetirementStatus.fulfilled, (state, action) => {
        state.UpdateMachineRetirementStatusData.data = action.payload;
      })
      .addCase(UpdateMachineRetirementStatus.rejected, (state, action) => {
        state.UpdateMachineRetirementStatusData.error = action.error.message;
      })
      .addCase(MachinePurchaseList.fulfilled, (state, action) => {
        state.MachinePurchaseListData.data = action.payload;
      })
      .addCase(MachinePurchaseList.rejected, (state, action) => {
        state.MachinePurchaseListData.error = action.error.message;
      })
      .addCase(GetListBySubscriberId.fulfilled, (state, action) => {
        state.GetListBySubscriberIdData.data = action.payload;
      })
      .addCase(GetListBySubscriberId.rejected, (state, action) => {
        state.GetListBySubscriberIdData.error = action.error.message;
      })
      .addCase(GetListBySearch.fulfilled, (state, action) => {
        state.GetListBySearchData.data = action.payload;
      })
      .addCase(GetListBySearch.rejected, (state, action) => {
        state.GetListBySearchData.error = action.error.message;
      })
      .addCase(DeprecateMachine.fulfilled, (state, action) => {
        state.DeprecateMachineData.data = action.payload;
      })
      .addCase(DeprecateMachine.rejected, (state, action) => {
        state.DeprecateMachineData.error = action.error.message;
      })
      .addCase(DiscontinueMachine.fulfilled, (state, action) => {
        state.DiscontinueMachineData.data = action.payload;
      })
      .addCase(DiscontinueMachine.rejected, (state, action) => {
        state.DiscontinueMachineData.error = action.error.message;
      })
      .addCase(UpdateMachine.fulfilled, (state, action) => {
        state.UpdateMachineData.data = action.payload;
      })
      .addCase(UpdateMachine.rejected, (state, action) => {
        state.UpdateMachineData.error = action.error.message;
      })
      .addCase(GetMachineDropdownList.fulfilled, (state, action) => {
        state.GetMachineDropdownListData.data = action.payload;
      })
      .addCase(GetMachineDropdownList.rejected, (state, action) => {
        state.GetMachineDropdownListData.error = action.error.message;
      })
      .addCase(GetMachinePortfolioList.fulfilled, (state, action) => {
        state.GetMachinePortfolioListData.data = action.payload;
      })
      .addCase(GetMachinePortfolioList.rejected, (state, action) => {
        state.GetMachinePortfolioListData.error = action.error.message;
      })
      .addCase(MachineVersionUpdate.fulfilled, (state, action) => {
        state.MachineVersionUpdateData.data = action.payload;
      })
      .addCase(MachineVersionUpdate.rejected, (state, action) => {
        state.MachineVersionUpdateData.error = action.error.message;
      })
      .addCase(SaveMachineSubscriber.fulfilled, (state, action) => {
        state.SaveMachineSubscriberData.data = action.payload;
      })
      .addCase(SaveMachineSubscriber.rejected, (state, action) => {
        state.SaveMachineSubscriberData.error = action.error.message;
      })
      .addCase(AssignPrivateMachine.fulfilled, (state, action) => {
        state.AssignPrivateMachineData.data = action.payload;
      })
      .addCase(AssignPrivateMachine.rejected, (state, action) => {
        state.AssignPrivateMachineData.error = action.error.message;
      })
      .addCase(GetSimilarMachineList.fulfilled, (state, action) => {
        state.GetSimilarMachineListData.data = action.payload;
      })
      .addCase(GetSimilarMachineList.rejected, (state, action) => {
        state.GetSimilarMachineListData.error = action.error.message;
      })
      .addCase(GetMachineVersionDetail.fulfilled, (state, action) => {
        state.GetMachineVersionDetailData.data = action.payload;
      })
      .addCase(GetMachineVersionDetail.rejected, (state, action) => {
        state.GetMachineVersionDetailData.error = action.error.message;
      })
      .addCase(GetMachineDashboardList.fulfilled, (state, action) => {
        state.GetMachineDashboardListData.data = action.payload;
      })
      .addCase(GetMachineDashboardList.rejected, (state, action) => {
        state.GetMachineDashboardListData.error = action.error.message;
      })
      .addCase(MachineRemoveFromLibrary.fulfilled, (state, action) => {
        state.MachineRemoveFromLibraryData.data = action.payload;
      })
      .addCase(MachineRemoveFromLibrary.rejected, (state, action) => {
        state.MachineRemoveFromLibraryData.error = action.error.message;
      });
  },
});

// export const { setLoader } = MachineSlice.actions;
export default MachineSlice.reducer;
